import { ref, onMounted, nextTick } from "vue";
import { templateRef } from "@vueuse/core";


export default {
  __name: 'index',
  props: {
  buttons: {
    type: Array,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const tpl_swiperEl = templateRef("tpl_swiperEl");
const swiper = ref(null);

onMounted(() => {
  nextTick(() => {
    requestAnimationFrame(() => {
      const swiperEl = tpl_swiperEl.value;
      const $slides = swiperEl.querySelectorAll("swiper-slide");
      let initialSlide = 0;

      for (let i = 0, len = $slides.length; i < len; i++) {
        if ($slides[i].querySelector(".nuxt-link-active")) {
          initialSlide = i;
          break;
        }
      }

      // Configure Swiper Element parameters
      const swiperParams = {
        slidesPerView: "auto",
        slideToClickedSlide: true,
        threshold: 10,
        spaceBetween: 24,
        slidesOffsetBefore: 24,
        slidesOffsetAfter: 24,
        roundLengths: true,
        freeMode: {
          enabled: true,
        },
        centerInsufficientSlides: true,
        resistance: true,
        resistanceRatio: 0,
        speed: 850,
        initialSlide: initialSlide,
        breakpoints: {
          600: {
            slidesOffsetBefore: 32,
            slidesOffsetAfter: 32,
          },
          1024: {
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            slideToClickedSlide: false,
          },
        },
      };

      // Assign parameters to the element
      Object.assign(swiperEl, swiperParams);

      // Initialize Swiper Element
      swiperEl.initialize();

      // Store swiper instance
      swiper.value = swiperEl.swiper;
    });
  });
});

return { __sfc: true,props, tpl_swiperEl, swiper }
}

}